<div
  class="search-movie-wrapper form-group {{ classStyle }} {{ !searchActive ? 'compacted' : '' }}"
  [ngClass]="{ 'with-filter': withFilters }"
  [class.component]="asComponent"
>
  @if (!searchComponentRedirect) {
    @if (withFilters) {
      <search-filters-dropdown />
    }

    <div class="search-autocomplete-wrap form-field" [ngClass]="{ active: active || getSearchActive() || asComponent }">
      <p-iconField [iconPosition]="searchIconPosition">
        <p-inputIcon
          *ngIf="(!searchActive && !active) || searchActive"
          (click)="onIconClick()"
          styleClass="pi {{ searchIcon }} {{ isLoading && searchIconPosition === 'right' ? 'hidden' : '' }}"
        />
        <p-inputIcon
          *ngIf="!searchActive && active"
          (click)="closeSearchBar()"
          styleClass="pi {{ closeIcon }}  {{ isLoading && searchIconPosition === 'right' ? 'hidden' : '' }}"
        />
        <p-autoComplete
          #autocomplete_movie
          id="autocomplete-movie"
          [(ngModel)]="selectedItem"
          [class.activeSearch]="active"
          [scrollHeight]="'80vh'"
          [delay]="700"
          minLength="3"
          optionLabel="title"
          [disabled]="searchComponentRedirect"
          [suggestions]="searchMovieService.results()"
          [showEmptyMessage]="true"
          [placeholder]="placeholder() | translate"
          emptyMessage="No results found"
          i18n-emptyMessage="@@public.filters.movie.noResultsFound"
          (completeMethod)="loadSuggestion($event)"
          (onSelect)="onSelect($event)"
          (onKeyUp)="onKeyup($event)"
          (onClear)="onClear()"
          (onBlur)="onBlur()"
        >
          <ng-template let-item pTemplate="item">
            <search-suggestion-item [item]="item" (itemSelect)="handleItemSelect($event)"></search-suggestion-item>
          </ng-template>
        </p-autoComplete>
      </p-iconField>
    </div>
  }
</div>
